module.exports = __webpack_public_path__ + "static/media/2.bf09d373.svg";